var _module_exports ="<div class=\"row\">\n    <!-- Main Content -->\n    <div ui-view=\"mainContent\">\n    </div>\n</div>\n";;
var path = '/app/Main/aric/certification/certification.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;